module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_6_A_20.ee734aaa.mp3";